import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-gray-50" style={{ paddingTop: '120px', paddingBottom: '80px' }}>
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 sm:p-12">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>

            <div className="prose prose-gray max-w-none">
              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  AirDelayClaim ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy 
                  explains how we collect, use, disclose, and safeguard your information when you use our services.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Information We Collect</h2>
                <p className="text-gray-600 leading-relaxed mb-4">We collect information that you provide directly to us:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li><strong>Personal Information:</strong> Name, email address, phone number, postal address</li>
                  <li><strong>Flight Information:</strong> Flight numbers, dates, booking references, ticket copies</li>
                  <li><strong>Identity Documents:</strong> Passport or ID copies (when required for claims)</li>
                  <li><strong>Payment Information:</strong> Bank account details for compensation transfers</li>
                  <li><strong>Communication Data:</strong> Correspondence with our support team</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">3. How We Use Your Information</h2>
                <p className="text-gray-600 leading-relaxed mb-4">We use collected information to:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Process and manage your compensation claim</li>
                  <li>Communicate with airlines on your behalf</li>
                  <li>Send you updates about your claim status</li>
                  <li>Transfer compensation payments to you</li>
                  <li>Improve our services and user experience</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Data Sharing</h2>
                <p className="text-gray-600 leading-relaxed mb-4">We may share your information with:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li><strong>Airlines:</strong> To process your compensation claim</li>
                  <li><strong>Legal Partners:</strong> If legal action is required</li>
                  <li><strong>Service Providers:</strong> Who assist in our operations (under strict confidentiality)</li>
                  <li><strong>Regulatory Bodies:</strong> When required by law</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Data Retention</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  We retain your personal data for as long as necessary to fulfill the purposes outlined in this 
                  policy, typically for 6 years after claim completion to comply with legal requirements.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Your Rights</h2>
                <p className="text-gray-600 leading-relaxed mb-4">Under applicable data protection laws, you have the right to:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Access your personal data</li>
                  <li>Correct inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to processing of your data</li>
                  <li>Request data portability</li>
                  <li>Withdraw consent at any time</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Security</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  We implement appropriate technical and organizational measures to protect your personal data, 
                  including encryption, secure servers, and access controls.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Contact Us</h2>
                <p className="text-gray-600 leading-relaxed">
                  For privacy-related inquiries, contact our Data Protection Officer at{' '}
                  <a href="mailto:info@airdelayclaim.com" className="text-blue-600 hover:underline">
                    info@airdelayclaim.com
                  </a>
                </p>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <Link 
                to="/" 
                className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
